import { palette } from '@peerless/ui-assets/palette';

export function getColorConversion(color: string) {
  switch (color) {
    case 'gray':
      return palette.gray.light;
    case 'red':
      return palette.primary.main;
    case 'white':
      return palette.primary.contrastText;
    case 'black':
      return palette.secondary.dark;
    default:
      return palette.primary.contrastText;
  }
}

export function getButtonColorConversion(color: string) {
  switch (color) {
    case 'red':
      return 'primary';
    case 'black':
      return 'secondary';
    default:
      return 'primary';
  }
}
